import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { fetchCountries } from 'src/store/lists/countries/asyncThunk';
import { checkIsLoading } from 'src/utils/types/statuses';
import {
  checkCanLoadCountries,
  getCountriesForSelect,
} from 'src/store/lists/countries/helpers';

import { BaseMultiSelect } from '../../../common';

type PCountriesMultiSelect = any;

export const CountriesMultiSelect: React.FC<PCountriesMultiSelect> = (
  props,
) => {
  const { label = 'Country/Region', ...otherProps } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    checkCanLoadCountries(() => dispatch(fetchCountries()));
  }, [dispatch]);

  const { status: countriesStatus } = useSelector(
    (state: RootState) => state.countries,
  );
  const countriesOptions = useSelector(getCountriesForSelect);

  return (
    <BaseMultiSelect
      options={countriesOptions}
      label={label}
      loading={checkIsLoading(countriesStatus)}
      {...otherProps}
    />
  );
};
